import { m } from 'framer-motion';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Stack, Box } from '@mui/material';
// components
import { MotionViewport, varFade } from '../../components/animate';
import Image from '../../components/Image';

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  width: '100%',
  textAlign: 'center',
  position: 'absolute',
  paddingTop: 30,
  left: 0,
  right: 0,
  zIndex: 10,
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    marginBottom: 0,
  },
}));

const CodeOverlayStyle = styled(Box)({
  zIndex: 9,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

export default function HomeCodeInvestissements() {
  return (
    <Stack component={MotionViewport}>
      <Stack width={1} position="relative">
        <CodeOverlayStyle component={m.div} variants={varFade().inRight}>
          <Image alt="code des investissements" src="/assets/background/code_des_investissements.jpg" />
        </CodeOverlayStyle>

        <Stack width={{ xs: 1, md: 0.4 }} height={270} sx={{ display: 'flex', alignItems: 'center' }}>
          <ContentStyle sx={{ pl: { xs: 0, md: 15 } }}>
            <m.div variants={varFade().inLeft}>
              <Typography variant="h2" color="#156c53" sx={{ mb: 3 }}>
                CODE DES <br />
                INVESTISSEMENTS
              </Typography>
            </m.div>
            <m.div variants={varFade().inLeft}>
              <Button size="large" color="error" variant="contained" target="_blank" rel="noopener" href="#">
                DÉCOUVRIR
              </Button>
            </m.div>
          </ContentStyle>
        </Stack>
      </Stack>
    </Stack>
  );
}
